/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Former_PlayersInputs */

const th_former_players = /** @type {(inputs: Former_PlayersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ผู้เล่นเดิม`)
};

const en_former_players = /** @type {(inputs: Former_PlayersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Former players`)
};

const ja_former_players = /** @type {(inputs: Former_PlayersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`元選手`)
};

const zh_former_players = /** @type {(inputs: Former_PlayersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`过往球员`)
};

const es_former_players = /** @type {(inputs: Former_PlayersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Antiguos jugadores`)
};

const pt_former_players = /** @type {(inputs: Former_PlayersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ex-jogadores`)
};

const id_former_players = /** @type {(inputs: Former_PlayersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mantan pemain`)
};

const fr_former_players = /** @type {(inputs: Former_PlayersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anciens joueurs`)
};

const tl_former_players = /** @type {(inputs: Former_PlayersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dating manlalaro`)
};

const vi_former_players = /** @type {(inputs: Former_PlayersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cầu thủ cũ`)
};

const ko_former_players = /** @type {(inputs: Former_PlayersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이전 선수`)
};

const de_former_players = /** @type {(inputs: Former_PlayersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ehemalige Spieler`)
};

const ru_former_players = /** @type {(inputs: Former_PlayersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Бывшие игроки`)
};

const tr_former_players = /** @type {(inputs: Former_PlayersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eski oyuncular`)
};

const it_former_players = /** @type {(inputs: Former_PlayersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ex giocatori`)
};

const pl_former_players = /** @type {(inputs: Former_PlayersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Byli zawodnicy`)
};

const uk_former_players = /** @type {(inputs: Former_PlayersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Колишні гравці`)
};

const hi_former_players = /** @type {(inputs: Former_PlayersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पूर्व खिलाड़ी`)
};

const ar_former_players = /** @type {(inputs: Former_PlayersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لاعبون سابقون`)
};

const ms_former_players = /** @type {(inputs: Former_PlayersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bekas pemain`)
};

const bn_former_players = /** @type {(inputs: Former_PlayersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`প্রাক্তন খেলোয়াড়`)
};

const zh_tw2_former_players = /** @type {(inputs: Former_PlayersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`過往球員`)
};

const zh_hk2_former_players = /** @type {(inputs: Former_PlayersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`過往球員`)
};

const ur_former_players = /** @type {(inputs: Former_PlayersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`سابق کھلاڑی`)
};

const fa_former_players = /** @type {(inputs: Former_PlayersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`بازیکنان پیشین`)
};

const sw_former_players = /** @type {(inputs: Former_PlayersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wachezaji wa zamani`)
};

const nl_former_players = /** @type {(inputs: Former_PlayersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oud-spelers`)
};

/**
* | output |
* | --- |
* | "Former players" |
*
* @param {Former_PlayersInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const former_players = /** @type {((inputs?: Former_PlayersInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Former_PlayersInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_former_players(inputs)
	if (locale === "ja") return ja_former_players(inputs)
	if (locale === "zh") return zh_former_players(inputs)
	if (locale === "es") return es_former_players(inputs)
	if (locale === "pt") return pt_former_players(inputs)
	if (locale === "id") return id_former_players(inputs)
	if (locale === "fr") return fr_former_players(inputs)
	if (locale === "tl") return tl_former_players(inputs)
	if (locale === "vi") return vi_former_players(inputs)
	if (locale === "ko") return ko_former_players(inputs)
	if (locale === "de") return de_former_players(inputs)
	if (locale === "ru") return ru_former_players(inputs)
	if (locale === "tr") return tr_former_players(inputs)
	if (locale === "it") return it_former_players(inputs)
	if (locale === "pl") return pl_former_players(inputs)
	if (locale === "uk") return uk_former_players(inputs)
	if (locale === "hi") return hi_former_players(inputs)
	if (locale === "ar") return ar_former_players(inputs)
	if (locale === "ms") return ms_former_players(inputs)
	if (locale === "bn") return bn_former_players(inputs)
	if (locale === "zh-TW") return zh_tw2_former_players(inputs)
	if (locale === "zh-HK") return zh_hk2_former_players(inputs)
	if (locale === "ur") return ur_former_players(inputs)
	if (locale === "fa") return fa_former_players(inputs)
	if (locale === "sw") return sw_former_players(inputs)
	if (locale === "nl") return nl_former_players(inputs)
	return en_former_players(inputs)
});